export enum NotificationTypeEnum {
    TICKET = 'Ticket',
    TASK = 'Task',
    ERROR_DETAIL_TASK_CHECK = 'ErrorDetailTaskCheck',
    VIOLATION_DETAIL_TASK_CHECK = 'ViolationDetailTaskCheck',
    DEVICE = 'Device',
    Warranty = 'Warranty',
    ChangePermission = 'ChangePermission',
}
